<p-dialog
    [(visible)]="visible"
    header=""
    [modal]="true"
    [style]="{ width: '440px' }"
    [closable]="true"
    [dismissableMask]="false"
    [closeOnEscape]="false"
    styleClass="prepost-dialog"
    (onHide)="onHide()"
    (onShow)="onDialogShow()"
    (keydown.enter)="onDialogEnter($event)"
>
    <ng-container *ngIf="wizardStep === 2">
        <div class="prepost-dialog-content">
            <div class="prepost-dialog-body">
                <div class="prepost-dialog-title">
                    <span>{{ selectedTypeLabel }}</span>
                </div>
                <div class="prepost-dialog-subtitle">Apply on Documents</div>
                <div class="prepost-dialog-options">
                    <div *ngFor="let target of documentTargets" class="prepost-dialog-option-row">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="selectedDocumentKeys.includes(target.key)"
                            (onChange)="toggleDocumentTarget(target.key, !!$event.checked)"
                        ></p-checkbox>
                        <span>{{ target.label }}</span>
                    </div>
                </div>
            </div>
            <div class="prepost-dialog-footer">
                <button
                    #okActionButton
                    pButton
                    type="button"
                    label="OK"
                    icon="pi pi-check"
                    (click)="goToTextEntry()"
                    [disabled]="!selectedDocumentKeys.length"
                ></button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="wizardStep === 3">
        <div class="p-fluid prepost-text-form" [class.prepost-page-transition]="pageTransitionActive">
            <div class="field mb-3 prepost-field">
                <label class="font-bold prepost-field-label">Text block</label>
                <input pInputText [value]="currentDocumentTarget?.key" readonly class="w-full prepost-readonly-input" />
            </div>
            <div class="field mb-3 prepost-field">
                <label class="font-bold prepost-field-label">Name</label>
                <input pInputText [value]="currentDocumentTarget?.label" readonly class="w-full prepost-readonly-input" />
            </div>
            <div class="field mb-3 prepost-field">
                <label class="font-bold prepost-field-label">Text</label>
                <textarea pInputTextarea rows="6" [(ngModel)]="documentTextInputs[currentDocumentIndex].text" class="w-full prepost-editable-input"></textarea>
            </div>
            <div class="flex align-items-center justify-content-between mt-4 prepost-nav-row">
                <small>{{ currentDocumentIndex + 1 }} of {{ documentTextInputs.length }} pages</small>
                <div class="flex gap-2">
                    <p-button label="Back" icon="pi pi-angle-left" text (click)="goToPreviousDocument()"></p-button>
                    <p-button
                        [label]="isLastDocumentPage ? 'Finish' : 'Next'"
                        icon="pi pi-angle-right"
                        (click)="goToNextDocument()"
                        (keydown.enter)="onNextEnter($event)"
                        [disabled]="!documentTextInputs[currentDocumentIndex].text.trim()"
                    ></p-button>
                </div>
            </div>
        </div>
    </ng-container>
</p-dialog>
